<template>
    <div class="client-history-widget">
        <div v-if="loading" class="text-muted">
            <i class="fa fa-spinner fa-spin"></i> Loading client history…
        </div>
        <table v-else-if="data" class="table table-condensed" style="margin-bottom: 0;">
            <tbody>
                <tr>
                    <td>Past orders</td>
                    <td><strong>{{ data.past_order_count }}</strong></td>
                </tr>
                <tr>
                    <td>Total spend (ex VAT)</td>
                    <td><strong>£{{ formatPounds(data.total_spend_pounds) }}</strong></td>
                </tr>
                <tr>
                    <td>OTIF</td>
                    <td>
                        <strong v-if="data.otif_percent !== null">{{ data.otif_percent }}%</strong>
                        <span v-else class="text-muted">—</span>
                    </td>
                </tr>
                <tr>
                    <td>Days since last order</td>
                    <td>
                        <strong v-if="data.days_since_last_order !== null">{{ data.days_since_last_order }}</strong>
                        <span v-else class="text-muted">—</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Avg payment delay
                        <i class="fa fa-info-circle text-muted" title="Deferred to v1.1 — needs paid_at column"></i>
                    </td>
                    <td><span class="text-muted">—</span></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
/*
    Block 2 client-history widget. Reads from
    /api/signoff/{quote}/client-history and renders a compact table
    Kev can scan at a glance.

    See planning/quote-signoff-design.md §5.2.
*/
export default {
    props: {
        quoteId: { type: [String, Number], required: true },
    },
    data() {
        return { loading: true, data: null };
    },
    mounted() { this.refresh(); },
    watch: {
        quoteId() { this.refresh(); },
    },
    methods: {
        refresh() {
            this.loading = true;
            fetch(`/api/signoff/${this.quoteId}/client-history`, { headers: { Accept: 'application/json' }})
                .then(r => r.json())
                .then(d => { this.data = d; this.loading = false; })
                .catch(() => { this.loading = false; });
        },
        formatPounds(n) {
            if (n == null) return '0';
            return Number(n).toLocaleString('en-GB');
        },
    },
};
</script>
